export class SessionStorageConstants {
  public static readonly Deal_Journey_Data = "Deal_Journey_Data";
}
